@if (officeDetail) {
  <div class="office">
    <app-office [office]="officeDetail.office" />
  </div>
}
@if (!officeDetail) {
  <div>No prescriber office in supplemental data</div>
}
